<template>
  <div>
    <wc-page-title title='All Deposits'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box
            title='Cheques & Cash'
            :titleIcon='toolbarData.icon'
            :titleIconColor='toolbarData.iconColor'
            showAdd
            @add='newDeposit'
            @toggleShowArchived='toggleShowArchived'
          >
            <v-data-table
              dense
              :loading='isLoading'
              :items='deposits'
              :headers='headers'
              :rows-per-page='20'
              @click:row='openDeposit'
            >
              <template v-slot:item.date='{ item }'>
                {{ item.date | shortDate }}
                <v-icon small color='red' v-if='item.is_locked'>mdi-lock</v-icon>
              </template>
              <template v-slot:item.amount='{ item }'>
                {{ item.amount | decMoney }}
              </template>
            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>

      <wc-dialog
        :showDialog='showDialog'
        title='New Deposit'
        :icon='toolbarData.icon'
        :iconColr='toolbarData.iconColor'
        width='350'
        :loading='isSaving'
        :disableButtons='!isFormValid'
        @cancel='showDialog = false'
        saveText='Continue'
        @save='saveDeposit'
      >
        <v-form v-model='isFormValid' ref='form'>
          <wc-datepicker
            label='Deposit date'
            required
            v-model='depositCopy.date'
            :min='this.$store.state.misc.accounting_settings.closed_fiscal_date'
          ></wc-datepicker>
          <v-select
            :items='accounts'
            item-text='name'
            item-value='id'
            label='Account'
            v-model='depositCopy.account'
            :rules='[rules.required]'
          ></v-select>
        </v-form>
      </wc-dialog>
    </v-container>
  </div>
</template>

<script>
import accountingAPI from '@/api/accounting';
import formRules from '@/mixins/formRules';
import moment from 'moment';

export default {
  name: 'all-deposits',
  mixins: [formRules],
  data: () => ({
    isLoading: true,
    isSaving: false,
    isFormValid: false,
    showArchived: false,
    showDialog: false,
    testPicker: { date: '' },
    accounts: [],
    deposits: [],
    depositCopy: {
      date: '',
      account: null,
      deposited_by: null,
      is_credit_card: false
    },
    headers: [
      { text: 'Deposit date', value: 'date' },
      { text: 'Account', value: 'account_obj.name' },
      { text: 'Amount', value: 'amount', align: 'right' }
    ]
  }),
  computed: {
    toolbarData () {
      return this.$store.state.icons.dataBox.deposits
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.deposits = await accountingAPI.getDeposits()
      this.accounts = await accountingAPI.getDepositAccounts()
      this.isLoading = false
    },
    toggleShowArchived () {
      this.showArchived = !this.showArchived
    },
    resetDepositCopy () {
      this.depositCopy.date = moment().format('YYYY-MM-DD').toString()
      this.depositCopy.account = null
      this.depositCopy.deposited_by = this.$store.state.auth.profile.id
      this.depositCopy.is_credit_card = false
    },
    newDeposit () {
      this.resetDepositCopy()
      this.showDialog = true
    },
    async saveDeposit () {
      this.isSaving = true
      let tmp = await accountingAPI.createDeposit(this.depositCopy)
      this.openDeposit(tmp)
    },
    openDeposit (row) {
      this.$router.push({ name: 'DepositDetail', params: { id: row.id } })
    }
  }
}
</script>
